import { apiSlice } from '../../api/apiSlice';
import {
    SubAccountsParams,
    SubAccountsResponse,
} from './subAccountsApiSliceTypes';

const subAccountsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSubAccounts: builder.query<SubAccountsResponse, SubAccountsParams>({
            query: (params) => ({
                url: `/dashboard/sub-accounts`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetSubAccountsQuery, useLazyGetSubAccountsQuery } =
    subAccountsApiSlice;
